import { createSlice } from '@reduxjs/toolkit';

export const DmpSlice = createSlice({
    name: "dmpslice",
    initialState: {
      appId:26,
      actionList:[],
      actionDashboard:{
          selectedId:-1,
          actionList:[],
          actionObj:{},
          
      },
      menuList:[],
  
        productList:[],
		productDashboard:{
            selectedId:-1,
            showEdit:false,
            productList:[],
            productObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			editProductModalOpen:false,
			manageProductModalOpen:false,
			linkImageModalOpen:false,
            
        },
        categoryList:[],
		categoryDashboard:{
            selectedId:-1,
            showEdit:false,
            categoryList:[],
            categoryObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        productcategoryList:[],
		productcategoryDashboard:{
            selectedId:-1,
            showEdit:false,
            productcategoryList:[],
            productcategoryObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        customerList:[],
		customerDashboard:{
            selectedId:-1,
            showEdit:false,
            customerList:[],
            customerObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        mlmuserList:[],
		mlmuserDashboard:{
            selectedId:-1,
            showEdit:false,
            mlmuserList:[],
            mlmuserObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			mlmusertypeid:'',
			mobilenumber:''
            },
            
			tandcModalOpen:false,
			onboardModalOpen:false,
			edituserModalOpen:false,
			initPartnershipModalOpen:false,
			managePartnershipModalOpen:false,
			AddUserModalOpen:false,
            
        },
        mlmusertypeList:[],
		mlmusertypeDashboard:{
            selectedId:-1,
            showEdit:false,
            mlmusertypeList:[],
            mlmusertypeObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        mlmcreditList:[],
		mlmcreditDashboard:{
            selectedId:-1,
            showEdit:false,
            mlmcreditList:[],
            mlmcreditObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        mlmorderList:[],
		mlmorderDashboard:{
            selectedId:-1,
            showEdit:false,
            mlmorderList:[],
            mlmorderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        razororderList:[],
		razororderDashboard:{
            selectedId:-1,
            showEdit:false,
            razororderList:[],
            razororderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			manageRazorOrderModalOpen:false,
            
        },
        razorsyncList:[],
		razorsyncDashboard:{
            selectedId:-1,
            showEdit:false,
            razorsyncList:[],
            razorsyncObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        transferreqList:[],
		transferreqDashboard:{
            selectedId:-1,
            showEdit:false,
            transferreqList:[],
            transferreqObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        payoutaccountList:[],
		payoutaccountDashboard:{
            selectedId:-1,
            showEdit:false,
            payoutaccountList:[],
            payoutaccountObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        razorwebhookList:[],
		razorwebhookDashboard:{
            selectedId:-1,
            showEdit:false,
            razorwebhookList:[],
            razorwebhookObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        businesscategoryList:[],
		businesscategoryDashboard:{
            selectedId:-1,
            showEdit:false,
            businesscategoryList:[],
            businesscategoryObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        businessserviceList:[],
		businessserviceDashboard:{
            selectedId:-1,
            showEdit:false,
            businessserviceList:[],
            businessserviceObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        businessservicedescList:[],
		businessservicedescDashboard:{
            selectedId:-1,
            showEdit:false,
            businessservicedescList:[],
            businessservicedescObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        businessserviceassetList:[],
		businessserviceassetDashboard:{
            selectedId:-1,
            showEdit:false,
            businessserviceassetList:[],
            businessserviceassetObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        businesstypeList:[],
		businesstypeDashboard:{
            selectedId:-1,
            showEdit:false,
            businesstypeList:[],
            businesstypeObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
    },
    reducers: {
        
        setActionList: (state, action) =>{
            state.actionList=action.payload;
            state.actionDashboard.actionList=action.payload;
        },
        setSelectedActionId: (state, action)=>{
            state.actionDashboard.selectedId=action.payload;

            state.actionDashboard.actionObj = state.actionList[
                state.actionList.findIndex(actionObj=>actionObj.id===parseInt(action.payload))
            ];
        },

        
        /* Product Reducer methods */
        setProductSorting: (state, action)=>{
            state.productDashboard.sorting=action.payload;
        },
        setProductFilterCriteria : (state, action)=>{
            state.productDashboard.filterCriteria=action.payload;
        },
        setShowEditForProduct: (state,action)=>{
            state.productDashboard.showEdit=action.payload;
            
			state.productDashboard.editProductModalOpen=false;
			state.productDashboard.manageProductModalOpen=false;
			state.productDashboard.linkImageModalOpen=false;
        },
        addProductObj: (state, action)=>{
            state.productList.unshift(action.payload);
            state.productDashboard.productList.unshift(action.payload);

            state.productDashboard.productObj=action.payload;
            state.productDashboard.selectedId=action.payload.id;
        },
        updateProductObj: (state, action)=>{
            let index = state.productList.map(productObj=>productObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productList[index]=action.payload;
            }

            index = state.productDashboard.productList.map(productObj=>productObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productDashboard.productList[index]=action.payload;
            }
            if (state.productDashboard.productObj!==null){
                state.productDashboard.productObj = action.payload;
            }
        },
        deleteProductObj: (state, action)=>{
            state.productList.splice(state.productList.findIndex(a => a.id === action.payload) , 1);
            state.productDashboard.productList.splice(state.productDashboard.productList.findIndex(a => a.id === action.payload) , 1);
            state.productDashboard.productObj={}
            state.productDashboard.selectedId=-1
        },
        setSelectedProductId: (state, action)=>{
            if (action.payload!==-1){
                state.productDashboard.selectedId=action.payload;
                state.productDashboard.productObj = state.productList[
                    state.productList.findIndex(productObj=>productObj.id===parseInt(action.payload))
            ];
            } else {
                state.productDashboard.selectedId=action.payload;
                state.productDashboard.productObj ={}
            }
        },
        setProductList: (state, action) =>{
            state.productList=action.payload;
            state.productDashboard.productList=action.payload;
        },
        setProductDashboardProductList: (state, action) =>{
            state.productDashboard.productList=action.payload;
        },
      
        setProductEditProductModal:(state,action)=>{
          state.productDashboard.editProductModalOpen=action.payload;
        },
      
        setProductManageProductModal:(state,action)=>{
          state.productDashboard.manageProductModalOpen=action.payload;
        },
      
        setProductLinkImageModal:(state,action)=>{
          state.productDashboard.linkImageModalOpen=action.payload;
        },
        /* Category Reducer methods */
        setCategorySorting: (state, action)=>{
            state.categoryDashboard.sorting=action.payload;
        },
        setCategoryFilterCriteria : (state, action)=>{
            state.categoryDashboard.filterCriteria=action.payload;
        },
        setShowEditForCategory: (state,action)=>{
            state.categoryDashboard.showEdit=action.payload;
            
        },
        addCategoryObj: (state, action)=>{
            state.categoryList.unshift(action.payload);
            state.categoryDashboard.categoryList.unshift(action.payload);

            state.categoryDashboard.categoryObj=action.payload;
            state.categoryDashboard.selectedId=action.payload.id;
        },
        updateCategoryObj: (state, action)=>{
            let index = state.categoryList.map(categoryObj=>categoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.categoryList[index]=action.payload;
            }

            index = state.categoryDashboard.categoryList.map(categoryObj=>categoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.categoryDashboard.categoryList[index]=action.payload;
            }
            if (state.categoryDashboard.categoryObj!==null){
                state.categoryDashboard.categoryObj = action.payload;
            }
        },
        deleteCategoryObj: (state, action)=>{
            state.categoryList.splice(state.categoryList.findIndex(a => a.id === action.payload) , 1);
            state.categoryDashboard.categoryList.splice(state.categoryDashboard.categoryList.findIndex(a => a.id === action.payload) , 1);
            state.categoryDashboard.productObj={}
            state.categoryDashboard.selectedId=-1
        },
        setSelectedCategoryId: (state, action)=>{
            if (action.payload!==-1){
                state.categoryDashboard.selectedId=action.payload;
                state.categoryDashboard.categoryObj = state.categoryList[
                    state.categoryList.findIndex(categoryObj=>categoryObj.id===parseInt(action.payload))
            ];
            } else {
                state.categoryDashboard.selectedId=action.payload;
                state.categoryDashboard.categoryObj ={}
            }
        },
        setCategoryList: (state, action) =>{
            state.categoryList=action.payload;
            state.categoryDashboard.categoryList=action.payload;
        },
        setCategoryDashboardCategoryList: (state, action) =>{
            state.categoryDashboard.categoryList=action.payload;
        },
        /* Productcategory Reducer methods */
        setProductcategorySorting: (state, action)=>{
            state.productcategoryDashboard.sorting=action.payload;
        },
        setProductcategoryFilterCriteria : (state, action)=>{
            state.productcategoryDashboard.filterCriteria=action.payload;
        },
        setShowEditForProductcategory: (state,action)=>{
            state.productcategoryDashboard.showEdit=action.payload;
            
        },
        addProductcategoryObj: (state, action)=>{
            state.productcategoryList.unshift(action.payload);
            state.productcategoryDashboard.productcategoryList.unshift(action.payload);

            state.productcategoryDashboard.productcategoryObj=action.payload;
            state.productcategoryDashboard.selectedId=action.payload.id;
        },
        updateProductcategoryObj: (state, action)=>{
            let index = state.productcategoryList.map(productcategoryObj=>productcategoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productcategoryList[index]=action.payload;
            }

            index = state.productcategoryDashboard.productcategoryList.map(productcategoryObj=>productcategoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productcategoryDashboard.productcategoryList[index]=action.payload;
            }
            if (state.productcategoryDashboard.productcategoryObj!==null){
                state.productcategoryDashboard.productcategoryObj = action.payload;
            }
        },
        deleteProductcategoryObj: (state, action)=>{
            state.productcategoryList.splice(state.productcategoryList.findIndex(a => a.id === action.payload) , 1);
            state.productcategoryDashboard.productcategoryList.splice(state.productcategoryDashboard.productcategoryList.findIndex(a => a.id === action.payload) , 1);
            state.productcategoryDashboard.productObj={}
            state.productcategoryDashboard.selectedId=-1
        },
        setSelectedProductcategoryId: (state, action)=>{
            if (action.payload!==-1){
                state.productcategoryDashboard.selectedId=action.payload;
                state.productcategoryDashboard.productcategoryObj = state.productcategoryList[
                    state.productcategoryList.findIndex(productcategoryObj=>productcategoryObj.id===parseInt(action.payload))
            ];
            } else {
                state.productcategoryDashboard.selectedId=action.payload;
                state.productcategoryDashboard.productcategoryObj ={}
            }
        },
        setProductcategoryList: (state, action) =>{
            state.productcategoryList=action.payload;
            state.productcategoryDashboard.productcategoryList=action.payload;
        },
        setProductcategoryDashboardProductcategoryList: (state, action) =>{
            state.productcategoryDashboard.productcategoryList=action.payload;
        },
        /* Customer Reducer methods */
        setCustomerSorting: (state, action)=>{
            state.customerDashboard.sorting=action.payload;
        },
        setCustomerFilterCriteria : (state, action)=>{
            state.customerDashboard.filterCriteria=action.payload;
        },
        setShowEditForCustomer: (state,action)=>{
            state.customerDashboard.showEdit=action.payload;
            
        },
        addCustomerObj: (state, action)=>{
            state.customerList.unshift(action.payload);
            state.customerDashboard.customerList.unshift(action.payload);

            state.customerDashboard.customerObj=action.payload;
            state.customerDashboard.selectedId=action.payload.id;
        },
        updateCustomerObj: (state, action)=>{
            let index = state.customerList.map(customerObj=>customerObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.customerList[index]=action.payload;
            }

            index = state.customerDashboard.customerList.map(customerObj=>customerObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.customerDashboard.customerList[index]=action.payload;
            }
            if (state.customerDashboard.customerObj!==null){
                state.customerDashboard.customerObj = action.payload;
            }
        },
        deleteCustomerObj: (state, action)=>{
            state.customerList.splice(state.customerList.findIndex(a => a.id === action.payload) , 1);
            state.customerDashboard.customerList.splice(state.customerDashboard.customerList.findIndex(a => a.id === action.payload) , 1);
            state.customerDashboard.productObj={}
            state.customerDashboard.selectedId=-1
        },
        setSelectedCustomerId: (state, action)=>{
            if (action.payload!==-1){
                state.customerDashboard.selectedId=action.payload;
                state.customerDashboard.customerObj = state.customerList[
                    state.customerList.findIndex(customerObj=>customerObj.id===parseInt(action.payload))
            ];
            } else {
                state.customerDashboard.selectedId=action.payload;
                state.customerDashboard.customerObj ={}
            }
        },
        setCustomerList: (state, action) =>{
            state.customerList=action.payload;
            state.customerDashboard.customerList=action.payload;
        },
        setCustomerDashboardCustomerList: (state, action) =>{
            state.customerDashboard.customerList=action.payload;
        },
        /* Mlmuser Reducer methods */
        setMlmuserSorting: (state, action)=>{
            state.mlmuserDashboard.sorting=action.payload;
        },
        setMlmuserFilterCriteria : (state, action)=>{
            state.mlmuserDashboard.filterCriteria=action.payload;
        },
        setShowEditForMlmuser: (state,action)=>{
            state.mlmuserDashboard.showEdit=action.payload;
            
			state.mlmuserDashboard.tandcModalOpen=false;
			state.mlmuserDashboard.onboardModalOpen=false;
			state.mlmuserDashboard.edituserModalOpen=false;
			state.mlmuserDashboard.initPartnershipModalOpen=false;
			state.mlmuserDashboard.managePartnershipModalOpen=false;
			state.mlmuserDashboard.AddUserModalOpen=false;
        },
        addMlmuserObj: (state, action)=>{
            state.mlmuserList.unshift(action.payload);
            state.mlmuserDashboard.mlmuserList.unshift(action.payload);

            state.mlmuserDashboard.mlmuserObj=action.payload;
            state.mlmuserDashboard.selectedId=action.payload.id;
        },
        updateMlmuserObj: (state, action)=>{
            let index = state.mlmuserList.map(mlmuserObj=>mlmuserObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mlmuserList[index]=action.payload;
            }

            index = state.mlmuserDashboard.mlmuserList.map(mlmuserObj=>mlmuserObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mlmuserDashboard.mlmuserList[index]=action.payload;
            }
            if (state.mlmuserDashboard.mlmuserObj!==null){
                state.mlmuserDashboard.mlmuserObj = action.payload;
            }
        },
        deleteMlmuserObj: (state, action)=>{
            state.mlmuserList.splice(state.mlmuserList.findIndex(a => a.id === action.payload) , 1);
            state.mlmuserDashboard.mlmuserList.splice(state.mlmuserDashboard.mlmuserList.findIndex(a => a.id === action.payload) , 1);
            state.mlmuserDashboard.productObj={}
            state.mlmuserDashboard.selectedId=-1
        },
        setSelectedMlmuserId: (state, action)=>{
            if (action.payload!==-1){
                state.mlmuserDashboard.selectedId=action.payload;
                state.mlmuserDashboard.mlmuserObj = state.mlmuserList[
                    state.mlmuserList.findIndex(mlmuserObj=>mlmuserObj.id===parseInt(action.payload))
            ];
            } else {
                state.mlmuserDashboard.selectedId=action.payload;
                state.mlmuserDashboard.mlmuserObj ={}
            }
        },
        setMlmuserList: (state, action) =>{
            state.mlmuserList=action.payload;
            state.mlmuserDashboard.mlmuserList=action.payload;
        },
        setMlmuserDashboardMlmuserList: (state, action) =>{
            state.mlmuserDashboard.mlmuserList=action.payload;
        },
      
        setMlmuserTandcModal:(state,action)=>{
          state.mlmuserDashboard.tandcModalOpen=action.payload;
        },
      
        setMlmuserOnboardModal:(state,action)=>{
          state.mlmuserDashboard.onboardModalOpen=action.payload;
        },
      
        setMlmuserEdituserModal:(state,action)=>{
          state.mlmuserDashboard.edituserModalOpen=action.payload;
        },
      
        setMlmuserInitPartnershipModal:(state,action)=>{
          state.mlmuserDashboard.initPartnershipModalOpen=action.payload;
        },
      
        setMlmuserManagePartnershipModal:(state,action)=>{
          state.mlmuserDashboard.managePartnershipModalOpen=action.payload;
        },
      
        setMlmuserAddUserModal:(state,action)=>{
          state.mlmuserDashboard.AddUserModalOpen=action.payload;
        },
        /* Mlmusertype Reducer methods */
        setMlmusertypeSorting: (state, action)=>{
            state.mlmusertypeDashboard.sorting=action.payload;
        },
        setMlmusertypeFilterCriteria : (state, action)=>{
            state.mlmusertypeDashboard.filterCriteria=action.payload;
        },
        setShowEditForMlmusertype: (state,action)=>{
            state.mlmusertypeDashboard.showEdit=action.payload;
            
        },
        addMlmusertypeObj: (state, action)=>{
            state.mlmusertypeList.unshift(action.payload);
            state.mlmusertypeDashboard.mlmusertypeList.unshift(action.payload);

            state.mlmusertypeDashboard.mlmusertypeObj=action.payload;
            state.mlmusertypeDashboard.selectedId=action.payload.id;
        },
        updateMlmusertypeObj: (state, action)=>{
            let index = state.mlmusertypeList.map(mlmusertypeObj=>mlmusertypeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mlmusertypeList[index]=action.payload;
            }

            index = state.mlmusertypeDashboard.mlmusertypeList.map(mlmusertypeObj=>mlmusertypeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mlmusertypeDashboard.mlmusertypeList[index]=action.payload;
            }
            if (state.mlmusertypeDashboard.mlmusertypeObj!==null){
                state.mlmusertypeDashboard.mlmusertypeObj = action.payload;
            }
        },
        deleteMlmusertypeObj: (state, action)=>{
            state.mlmusertypeList.splice(state.mlmusertypeList.findIndex(a => a.id === action.payload) , 1);
            state.mlmusertypeDashboard.mlmusertypeList.splice(state.mlmusertypeDashboard.mlmusertypeList.findIndex(a => a.id === action.payload) , 1);
            state.mlmusertypeDashboard.productObj={}
            state.mlmusertypeDashboard.selectedId=-1
        },
        setSelectedMlmusertypeId: (state, action)=>{
            if (action.payload!==-1){
                state.mlmusertypeDashboard.selectedId=action.payload;
                state.mlmusertypeDashboard.mlmusertypeObj = state.mlmusertypeList[
                    state.mlmusertypeList.findIndex(mlmusertypeObj=>mlmusertypeObj.id===parseInt(action.payload))
            ];
            } else {
                state.mlmusertypeDashboard.selectedId=action.payload;
                state.mlmusertypeDashboard.mlmusertypeObj ={}
            }
        },
        setMlmusertypeList: (state, action) =>{
            state.mlmusertypeList=action.payload;
            state.mlmusertypeDashboard.mlmusertypeList=action.payload;
        },
        setMlmusertypeDashboardMlmusertypeList: (state, action) =>{
            state.mlmusertypeDashboard.mlmusertypeList=action.payload;
        },
        /* Mlmcredit Reducer methods */
        setMlmcreditSorting: (state, action)=>{
            state.mlmcreditDashboard.sorting=action.payload;
        },
        setMlmcreditFilterCriteria : (state, action)=>{
            state.mlmcreditDashboard.filterCriteria=action.payload;
        },
        setShowEditForMlmcredit: (state,action)=>{
            state.mlmcreditDashboard.showEdit=action.payload;
            
        },
        addMlmcreditObj: (state, action)=>{
            state.mlmcreditList.unshift(action.payload);
            state.mlmcreditDashboard.mlmcreditList.unshift(action.payload);

            state.mlmcreditDashboard.mlmcreditObj=action.payload;
            state.mlmcreditDashboard.selectedId=action.payload.id;
        },
        updateMlmcreditObj: (state, action)=>{
            let index = state.mlmcreditList.map(mlmcreditObj=>mlmcreditObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mlmcreditList[index]=action.payload;
            }

            index = state.mlmcreditDashboard.mlmcreditList.map(mlmcreditObj=>mlmcreditObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mlmcreditDashboard.mlmcreditList[index]=action.payload;
            }
            if (state.mlmcreditDashboard.mlmcreditObj!==null){
                state.mlmcreditDashboard.mlmcreditObj = action.payload;
            }
        },
        deleteMlmcreditObj: (state, action)=>{
            state.mlmcreditList.splice(state.mlmcreditList.findIndex(a => a.id === action.payload) , 1);
            state.mlmcreditDashboard.mlmcreditList.splice(state.mlmcreditDashboard.mlmcreditList.findIndex(a => a.id === action.payload) , 1);
            state.mlmcreditDashboard.productObj={}
            state.mlmcreditDashboard.selectedId=-1
        },
        setSelectedMlmcreditId: (state, action)=>{
            if (action.payload!==-1){
                state.mlmcreditDashboard.selectedId=action.payload;
                state.mlmcreditDashboard.mlmcreditObj = state.mlmcreditList[
                    state.mlmcreditList.findIndex(mlmcreditObj=>mlmcreditObj.id===parseInt(action.payload))
            ];
            } else {
                state.mlmcreditDashboard.selectedId=action.payload;
                state.mlmcreditDashboard.mlmcreditObj ={}
            }
        },
        setMlmcreditList: (state, action) =>{
            state.mlmcreditList=action.payload;
            state.mlmcreditDashboard.mlmcreditList=action.payload;
        },
        setMlmcreditDashboardMlmcreditList: (state, action) =>{
            state.mlmcreditDashboard.mlmcreditList=action.payload;
        },
        /* Mlmorder Reducer methods */
        setMlmorderSorting: (state, action)=>{
            state.mlmorderDashboard.sorting=action.payload;
        },
        setMlmorderFilterCriteria : (state, action)=>{
            state.mlmorderDashboard.filterCriteria=action.payload;
        },
        setShowEditForMlmorder: (state,action)=>{
            state.mlmorderDashboard.showEdit=action.payload;
            
        },
        addMlmorderObj: (state, action)=>{
            state.mlmorderList.unshift(action.payload);
            state.mlmorderDashboard.mlmorderList.unshift(action.payload);

            state.mlmorderDashboard.mlmorderObj=action.payload;
            state.mlmorderDashboard.selectedId=action.payload.id;
        },
        updateMlmorderObj: (state, action)=>{
            let index = state.mlmorderList.map(mlmorderObj=>mlmorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mlmorderList[index]=action.payload;
            }

            index = state.mlmorderDashboard.mlmorderList.map(mlmorderObj=>mlmorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mlmorderDashboard.mlmorderList[index]=action.payload;
            }
            if (state.mlmorderDashboard.mlmorderObj!==null){
                state.mlmorderDashboard.mlmorderObj = action.payload;
            }
        },
        deleteMlmorderObj: (state, action)=>{
            state.mlmorderList.splice(state.mlmorderList.findIndex(a => a.id === action.payload) , 1);
            state.mlmorderDashboard.mlmorderList.splice(state.mlmorderDashboard.mlmorderList.findIndex(a => a.id === action.payload) , 1);
            state.mlmorderDashboard.productObj={}
            state.mlmorderDashboard.selectedId=-1
        },
        setSelectedMlmorderId: (state, action)=>{
            if (action.payload!==-1){
                state.mlmorderDashboard.selectedId=action.payload;
                state.mlmorderDashboard.mlmorderObj = state.mlmorderList[
                    state.mlmorderList.findIndex(mlmorderObj=>mlmorderObj.id===parseInt(action.payload))
            ];
            } else {
                state.mlmorderDashboard.selectedId=action.payload;
                state.mlmorderDashboard.mlmorderObj ={}
            }
        },
        setMlmorderList: (state, action) =>{
            state.mlmorderList=action.payload;
            state.mlmorderDashboard.mlmorderList=action.payload;
        },
        setMlmorderDashboardMlmorderList: (state, action) =>{
            state.mlmorderDashboard.mlmorderList=action.payload;
        },
        /* Razororder Reducer methods */
        setRazororderSorting: (state, action)=>{
            state.razororderDashboard.sorting=action.payload;
        },
        setRazororderFilterCriteria : (state, action)=>{
            state.razororderDashboard.filterCriteria=action.payload;
        },
        setShowEditForRazororder: (state,action)=>{
            state.razororderDashboard.showEdit=action.payload;
            
			state.razororderDashboard.manageRazorOrderModalOpen=false;
        },
        addRazororderObj: (state, action)=>{
            state.razororderList.unshift(action.payload);
            state.razororderDashboard.razororderList.unshift(action.payload);

            state.razororderDashboard.razororderObj=action.payload;
            state.razororderDashboard.selectedId=action.payload.id;
        },
        updateRazororderObj: (state, action)=>{
            let index = state.razororderList.map(razororderObj=>razororderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.razororderList[index]=action.payload;
            }

            index = state.razororderDashboard.razororderList.map(razororderObj=>razororderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.razororderDashboard.razororderList[index]=action.payload;
            }
            if (state.razororderDashboard.razororderObj!==null){
                state.razororderDashboard.razororderObj = action.payload;
            }
        },
        deleteRazororderObj: (state, action)=>{
            state.razororderList.splice(state.razororderList.findIndex(a => a.id === action.payload) , 1);
            state.razororderDashboard.razororderList.splice(state.razororderDashboard.razororderList.findIndex(a => a.id === action.payload) , 1);
            state.razororderDashboard.productObj={}
            state.razororderDashboard.selectedId=-1
        },
        setSelectedRazororderId: (state, action)=>{
            if (action.payload!==-1){
                state.razororderDashboard.selectedId=action.payload;
                state.razororderDashboard.razororderObj = state.razororderList[
                    state.razororderList.findIndex(razororderObj=>razororderObj.id===parseInt(action.payload))
            ];
            } else {
                state.razororderDashboard.selectedId=action.payload;
                state.razororderDashboard.razororderObj ={}
            }
        },
        setRazororderList: (state, action) =>{
            state.razororderList=action.payload;
            state.razororderDashboard.razororderList=action.payload;
        },
        setRazororderDashboardRazororderList: (state, action) =>{
            state.razororderDashboard.razororderList=action.payload;
        },
      
        setRazororderManageRazorOrderModal:(state,action)=>{
          state.razororderDashboard.manageRazorOrderModalOpen=action.payload;
        },
        /* Razorsync Reducer methods */
        setRazorsyncSorting: (state, action)=>{
            state.razorsyncDashboard.sorting=action.payload;
        },
        setRazorsyncFilterCriteria : (state, action)=>{
            state.razorsyncDashboard.filterCriteria=action.payload;
        },
        setShowEditForRazorsync: (state,action)=>{
            state.razorsyncDashboard.showEdit=action.payload;
            
        },
        addRazorsyncObj: (state, action)=>{
            state.razorsyncList.unshift(action.payload);
            state.razorsyncDashboard.razorsyncList.unshift(action.payload);

            state.razorsyncDashboard.razorsyncObj=action.payload;
            state.razorsyncDashboard.selectedId=action.payload.id;
        },
        updateRazorsyncObj: (state, action)=>{
            let index = state.razorsyncList.map(razorsyncObj=>razorsyncObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.razorsyncList[index]=action.payload;
            }

            index = state.razorsyncDashboard.razorsyncList.map(razorsyncObj=>razorsyncObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.razorsyncDashboard.razorsyncList[index]=action.payload;
            }
            if (state.razorsyncDashboard.razorsyncObj!==null){
                state.razorsyncDashboard.razorsyncObj = action.payload;
            }
        },
        deleteRazorsyncObj: (state, action)=>{
            state.razorsyncList.splice(state.razorsyncList.findIndex(a => a.id === action.payload) , 1);
            state.razorsyncDashboard.razorsyncList.splice(state.razorsyncDashboard.razorsyncList.findIndex(a => a.id === action.payload) , 1);
            state.razorsyncDashboard.productObj={}
            state.razorsyncDashboard.selectedId=-1
        },
        setSelectedRazorsyncId: (state, action)=>{
            if (action.payload!==-1){
                state.razorsyncDashboard.selectedId=action.payload;
                state.razorsyncDashboard.razorsyncObj = state.razorsyncList[
                    state.razorsyncList.findIndex(razorsyncObj=>razorsyncObj.id===parseInt(action.payload))
            ];
            } else {
                state.razorsyncDashboard.selectedId=action.payload;
                state.razorsyncDashboard.razorsyncObj ={}
            }
        },
        setRazorsyncList: (state, action) =>{
            state.razorsyncList=action.payload;
            state.razorsyncDashboard.razorsyncList=action.payload;
        },
        setRazorsyncDashboardRazorsyncList: (state, action) =>{
            state.razorsyncDashboard.razorsyncList=action.payload;
        },
        /* Transferreq Reducer methods */
        setTransferreqSorting: (state, action)=>{
            state.transferreqDashboard.sorting=action.payload;
        },
        setTransferreqFilterCriteria : (state, action)=>{
            state.transferreqDashboard.filterCriteria=action.payload;
        },
        setShowEditForTransferreq: (state,action)=>{
            state.transferreqDashboard.showEdit=action.payload;
            
        },
        addTransferreqObj: (state, action)=>{
            state.transferreqList.unshift(action.payload);
            state.transferreqDashboard.transferreqList.unshift(action.payload);

            state.transferreqDashboard.transferreqObj=action.payload;
            state.transferreqDashboard.selectedId=action.payload.id;
        },
        updateTransferreqObj: (state, action)=>{
            let index = state.transferreqList.map(transferreqObj=>transferreqObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.transferreqList[index]=action.payload;
            }

            index = state.transferreqDashboard.transferreqList.map(transferreqObj=>transferreqObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.transferreqDashboard.transferreqList[index]=action.payload;
            }
            if (state.transferreqDashboard.transferreqObj!==null){
                state.transferreqDashboard.transferreqObj = action.payload;
            }
        },
        deleteTransferreqObj: (state, action)=>{
            state.transferreqList.splice(state.transferreqList.findIndex(a => a.id === action.payload) , 1);
            state.transferreqDashboard.transferreqList.splice(state.transferreqDashboard.transferreqList.findIndex(a => a.id === action.payload) , 1);
            state.transferreqDashboard.productObj={}
            state.transferreqDashboard.selectedId=-1
        },
        setSelectedTransferreqId: (state, action)=>{
            if (action.payload!==-1){
                state.transferreqDashboard.selectedId=action.payload;
                state.transferreqDashboard.transferreqObj = state.transferreqList[
                    state.transferreqList.findIndex(transferreqObj=>transferreqObj.id===parseInt(action.payload))
            ];
            } else {
                state.transferreqDashboard.selectedId=action.payload;
                state.transferreqDashboard.transferreqObj ={}
            }
        },
        setTransferreqList: (state, action) =>{
            state.transferreqList=action.payload;
            state.transferreqDashboard.transferreqList=action.payload;
        },
        setTransferreqDashboardTransferreqList: (state, action) =>{
            state.transferreqDashboard.transferreqList=action.payload;
        },
        /* Payoutaccount Reducer methods */
        setPayoutaccountSorting: (state, action)=>{
            state.payoutaccountDashboard.sorting=action.payload;
        },
        setPayoutaccountFilterCriteria : (state, action)=>{
            state.payoutaccountDashboard.filterCriteria=action.payload;
        },
        setShowEditForPayoutaccount: (state,action)=>{
            state.payoutaccountDashboard.showEdit=action.payload;
            
        },
        addPayoutaccountObj: (state, action)=>{
            state.payoutaccountList.unshift(action.payload);
            state.payoutaccountDashboard.payoutaccountList.unshift(action.payload);

            state.payoutaccountDashboard.payoutaccountObj=action.payload;
            state.payoutaccountDashboard.selectedId=action.payload.id;
        },
        updatePayoutaccountObj: (state, action)=>{
            let index = state.payoutaccountList.map(payoutaccountObj=>payoutaccountObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.payoutaccountList[index]=action.payload;
            }

            index = state.payoutaccountDashboard.payoutaccountList.map(payoutaccountObj=>payoutaccountObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.payoutaccountDashboard.payoutaccountList[index]=action.payload;
            }
            if (state.payoutaccountDashboard.payoutaccountObj!==null){
                state.payoutaccountDashboard.payoutaccountObj = action.payload;
            }
        },
        deletePayoutaccountObj: (state, action)=>{
            state.payoutaccountList.splice(state.payoutaccountList.findIndex(a => a.id === action.payload) , 1);
            state.payoutaccountDashboard.payoutaccountList.splice(state.payoutaccountDashboard.payoutaccountList.findIndex(a => a.id === action.payload) , 1);
            state.payoutaccountDashboard.productObj={}
            state.payoutaccountDashboard.selectedId=-1
        },
        setSelectedPayoutaccountId: (state, action)=>{
            if (action.payload!==-1){
                state.payoutaccountDashboard.selectedId=action.payload;
                state.payoutaccountDashboard.payoutaccountObj = state.payoutaccountList[
                    state.payoutaccountList.findIndex(payoutaccountObj=>payoutaccountObj.id===parseInt(action.payload))
            ];
            } else {
                state.payoutaccountDashboard.selectedId=action.payload;
                state.payoutaccountDashboard.payoutaccountObj ={}
            }
        },
        setPayoutaccountList: (state, action) =>{
            state.payoutaccountList=action.payload;
            state.payoutaccountDashboard.payoutaccountList=action.payload;
        },
        setPayoutaccountDashboardPayoutaccountList: (state, action) =>{
            state.payoutaccountDashboard.payoutaccountList=action.payload;
        },
        /* Razorwebhook Reducer methods */
        setRazorwebhookSorting: (state, action)=>{
            state.razorwebhookDashboard.sorting=action.payload;
        },
        setRazorwebhookFilterCriteria : (state, action)=>{
            state.razorwebhookDashboard.filterCriteria=action.payload;
        },
        setShowEditForRazorwebhook: (state,action)=>{
            state.razorwebhookDashboard.showEdit=action.payload;
            
        },
        addRazorwebhookObj: (state, action)=>{
            state.razorwebhookList.unshift(action.payload);
            state.razorwebhookDashboard.razorwebhookList.unshift(action.payload);

            state.razorwebhookDashboard.razorwebhookObj=action.payload;
            state.razorwebhookDashboard.selectedId=action.payload.id;
        },
        updateRazorwebhookObj: (state, action)=>{
            let index = state.razorwebhookList.map(razorwebhookObj=>razorwebhookObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.razorwebhookList[index]=action.payload;
            }

            index = state.razorwebhookDashboard.razorwebhookList.map(razorwebhookObj=>razorwebhookObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.razorwebhookDashboard.razorwebhookList[index]=action.payload;
            }
            if (state.razorwebhookDashboard.razorwebhookObj!==null){
                state.razorwebhookDashboard.razorwebhookObj = action.payload;
            }
        },
        deleteRazorwebhookObj: (state, action)=>{
            state.razorwebhookList.splice(state.razorwebhookList.findIndex(a => a.id === action.payload) , 1);
            state.razorwebhookDashboard.razorwebhookList.splice(state.razorwebhookDashboard.razorwebhookList.findIndex(a => a.id === action.payload) , 1);
            state.razorwebhookDashboard.productObj={}
            state.razorwebhookDashboard.selectedId=-1
        },
        setSelectedRazorwebhookId: (state, action)=>{
            if (action.payload!==-1){
                state.razorwebhookDashboard.selectedId=action.payload;
                state.razorwebhookDashboard.razorwebhookObj = state.razorwebhookList[
                    state.razorwebhookList.findIndex(razorwebhookObj=>razorwebhookObj.id===parseInt(action.payload))
            ];
            } else {
                state.razorwebhookDashboard.selectedId=action.payload;
                state.razorwebhookDashboard.razorwebhookObj ={}
            }
        },
        setRazorwebhookList: (state, action) =>{
            state.razorwebhookList=action.payload;
            state.razorwebhookDashboard.razorwebhookList=action.payload;
        },
        setRazorwebhookDashboardRazorwebhookList: (state, action) =>{
            state.razorwebhookDashboard.razorwebhookList=action.payload;
        },
        /* Businesscategory Reducer methods */
        setBusinesscategorySorting: (state, action)=>{
            state.businesscategoryDashboard.sorting=action.payload;
        },
        setBusinesscategoryFilterCriteria : (state, action)=>{
            state.businesscategoryDashboard.filterCriteria=action.payload;
        },
        setShowEditForBusinesscategory: (state,action)=>{
            state.businesscategoryDashboard.showEdit=action.payload;
            
        },
        addBusinesscategoryObj: (state, action)=>{
            state.businesscategoryList.unshift(action.payload);
            state.businesscategoryDashboard.businesscategoryList.unshift(action.payload);

            state.businesscategoryDashboard.businesscategoryObj=action.payload;
            state.businesscategoryDashboard.selectedId=action.payload.id;
        },
        updateBusinesscategoryObj: (state, action)=>{
            let index = state.businesscategoryList.map(businesscategoryObj=>businesscategoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businesscategoryList[index]=action.payload;
            }

            index = state.businesscategoryDashboard.businesscategoryList.map(businesscategoryObj=>businesscategoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businesscategoryDashboard.businesscategoryList[index]=action.payload;
            }
            if (state.businesscategoryDashboard.businesscategoryObj!==null){
                state.businesscategoryDashboard.businesscategoryObj = action.payload;
            }
        },
        deleteBusinesscategoryObj: (state, action)=>{
            state.businesscategoryList.splice(state.businesscategoryList.findIndex(a => a.id === action.payload) , 1);
            state.businesscategoryDashboard.businesscategoryList.splice(state.businesscategoryDashboard.businesscategoryList.findIndex(a => a.id === action.payload) , 1);
            state.businesscategoryDashboard.productObj={}
            state.businesscategoryDashboard.selectedId=-1
        },
        setSelectedBusinesscategoryId: (state, action)=>{
            if (action.payload!==-1){
                state.businesscategoryDashboard.selectedId=action.payload;
                state.businesscategoryDashboard.businesscategoryObj = state.businesscategoryList[
                    state.businesscategoryList.findIndex(businesscategoryObj=>businesscategoryObj.id===parseInt(action.payload))
            ];
            } else {
                state.businesscategoryDashboard.selectedId=action.payload;
                state.businesscategoryDashboard.businesscategoryObj ={}
            }
        },
        setBusinesscategoryList: (state, action) =>{
            state.businesscategoryList=action.payload;
            state.businesscategoryDashboard.businesscategoryList=action.payload;
        },
        setBusinesscategoryDashboardBusinesscategoryList: (state, action) =>{
            state.businesscategoryDashboard.businesscategoryList=action.payload;
        },
        /* Businessservice Reducer methods */
        setBusinessserviceSorting: (state, action)=>{
            state.businessserviceDashboard.sorting=action.payload;
        },
        setBusinessserviceFilterCriteria : (state, action)=>{
            state.businessserviceDashboard.filterCriteria=action.payload;
        },
        setShowEditForBusinessservice: (state,action)=>{
            state.businessserviceDashboard.showEdit=action.payload;
            
        },
        addBusinessserviceObj: (state, action)=>{
            state.businessserviceList.unshift(action.payload);
            state.businessserviceDashboard.businessserviceList.unshift(action.payload);

            state.businessserviceDashboard.businessserviceObj=action.payload;
            state.businessserviceDashboard.selectedId=action.payload.id;
        },
        updateBusinessserviceObj: (state, action)=>{
            let index = state.businessserviceList.map(businessserviceObj=>businessserviceObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businessserviceList[index]=action.payload;
            }

            index = state.businessserviceDashboard.businessserviceList.map(businessserviceObj=>businessserviceObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businessserviceDashboard.businessserviceList[index]=action.payload;
            }
            if (state.businessserviceDashboard.businessserviceObj!==null){
                state.businessserviceDashboard.businessserviceObj = action.payload;
            }
        },
        deleteBusinessserviceObj: (state, action)=>{
            state.businessserviceList.splice(state.businessserviceList.findIndex(a => a.id === action.payload) , 1);
            state.businessserviceDashboard.businessserviceList.splice(state.businessserviceDashboard.businessserviceList.findIndex(a => a.id === action.payload) , 1);
            state.businessserviceDashboard.productObj={}
            state.businessserviceDashboard.selectedId=-1
        },
        setSelectedBusinessserviceId: (state, action)=>{
            if (action.payload!==-1){
                state.businessserviceDashboard.selectedId=action.payload;
                state.businessserviceDashboard.businessserviceObj = state.businessserviceList[
                    state.businessserviceList.findIndex(businessserviceObj=>businessserviceObj.id===parseInt(action.payload))
            ];
            } else {
                state.businessserviceDashboard.selectedId=action.payload;
                state.businessserviceDashboard.businessserviceObj ={}
            }
        },
        setBusinessserviceList: (state, action) =>{
            state.businessserviceList=action.payload;
            state.businessserviceDashboard.businessserviceList=action.payload;
        },
        setBusinessserviceDashboardBusinessserviceList: (state, action) =>{
            state.businessserviceDashboard.businessserviceList=action.payload;
        },
        /* Businessservicedesc Reducer methods */
        setBusinessservicedescSorting: (state, action)=>{
            state.businessservicedescDashboard.sorting=action.payload;
        },
        setBusinessservicedescFilterCriteria : (state, action)=>{
            state.businessservicedescDashboard.filterCriteria=action.payload;
        },
        setShowEditForBusinessservicedesc: (state,action)=>{
            state.businessservicedescDashboard.showEdit=action.payload;
            
        },
        addBusinessservicedescObj: (state, action)=>{
            state.businessservicedescList.unshift(action.payload);
            state.businessservicedescDashboard.businessservicedescList.unshift(action.payload);

            state.businessservicedescDashboard.businessservicedescObj=action.payload;
            state.businessservicedescDashboard.selectedId=action.payload.id;
        },
        updateBusinessservicedescObj: (state, action)=>{
            let index = state.businessservicedescList.map(businessservicedescObj=>businessservicedescObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businessservicedescList[index]=action.payload;
            }

            index = state.businessservicedescDashboard.businessservicedescList.map(businessservicedescObj=>businessservicedescObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businessservicedescDashboard.businessservicedescList[index]=action.payload;
            }
            if (state.businessservicedescDashboard.businessservicedescObj!==null){
                state.businessservicedescDashboard.businessservicedescObj = action.payload;
            }
        },
        deleteBusinessservicedescObj: (state, action)=>{
            state.businessservicedescList.splice(state.businessservicedescList.findIndex(a => a.id === action.payload) , 1);
            state.businessservicedescDashboard.businessservicedescList.splice(state.businessservicedescDashboard.businessservicedescList.findIndex(a => a.id === action.payload) , 1);
            state.businessservicedescDashboard.productObj={}
            state.businessservicedescDashboard.selectedId=-1
        },
        setSelectedBusinessservicedescId: (state, action)=>{
            if (action.payload!==-1){
                state.businessservicedescDashboard.selectedId=action.payload;
                state.businessservicedescDashboard.businessservicedescObj = state.businessservicedescList[
                    state.businessservicedescList.findIndex(businessservicedescObj=>businessservicedescObj.id===parseInt(action.payload))
            ];
            } else {
                state.businessservicedescDashboard.selectedId=action.payload;
                state.businessservicedescDashboard.businessservicedescObj ={}
            }
        },
        setBusinessservicedescList: (state, action) =>{
            state.businessservicedescList=action.payload;
            state.businessservicedescDashboard.businessservicedescList=action.payload;
        },
        setBusinessservicedescDashboardBusinessservicedescList: (state, action) =>{
            state.businessservicedescDashboard.businessservicedescList=action.payload;
        },
        /* Businessserviceasset Reducer methods */
        setBusinessserviceassetSorting: (state, action)=>{
            state.businessserviceassetDashboard.sorting=action.payload;
        },
        setBusinessserviceassetFilterCriteria : (state, action)=>{
            state.businessserviceassetDashboard.filterCriteria=action.payload;
        },
        setShowEditForBusinessserviceasset: (state,action)=>{
            state.businessserviceassetDashboard.showEdit=action.payload;
            
        },
        addBusinessserviceassetObj: (state, action)=>{
            state.businessserviceassetList.unshift(action.payload);
            state.businessserviceassetDashboard.businessserviceassetList.unshift(action.payload);

            state.businessserviceassetDashboard.businessserviceassetObj=action.payload;
            state.businessserviceassetDashboard.selectedId=action.payload.id;
        },
        updateBusinessserviceassetObj: (state, action)=>{
            let index = state.businessserviceassetList.map(businessserviceassetObj=>businessserviceassetObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businessserviceassetList[index]=action.payload;
            }

            index = state.businessserviceassetDashboard.businessserviceassetList.map(businessserviceassetObj=>businessserviceassetObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businessserviceassetDashboard.businessserviceassetList[index]=action.payload;
            }
            if (state.businessserviceassetDashboard.businessserviceassetObj!==null){
                state.businessserviceassetDashboard.businessserviceassetObj = action.payload;
            }
        },
        deleteBusinessserviceassetObj: (state, action)=>{
            state.businessserviceassetList.splice(state.businessserviceassetList.findIndex(a => a.id === action.payload) , 1);
            state.businessserviceassetDashboard.businessserviceassetList.splice(state.businessserviceassetDashboard.businessserviceassetList.findIndex(a => a.id === action.payload) , 1);
            state.businessserviceassetDashboard.productObj={}
            state.businessserviceassetDashboard.selectedId=-1
        },
        setSelectedBusinessserviceassetId: (state, action)=>{
            if (action.payload!==-1){
                state.businessserviceassetDashboard.selectedId=action.payload;
                state.businessserviceassetDashboard.businessserviceassetObj = state.businessserviceassetList[
                    state.businessserviceassetList.findIndex(businessserviceassetObj=>businessserviceassetObj.id===parseInt(action.payload))
            ];
            } else {
                state.businessserviceassetDashboard.selectedId=action.payload;
                state.businessserviceassetDashboard.businessserviceassetObj ={}
            }
        },
        setBusinessserviceassetList: (state, action) =>{
            state.businessserviceassetList=action.payload;
            state.businessserviceassetDashboard.businessserviceassetList=action.payload;
        },
        setBusinessserviceassetDashboardBusinessserviceassetList: (state, action) =>{
            state.businessserviceassetDashboard.businessserviceassetList=action.payload;
        },
        /* Businesstype Reducer methods */
        setBusinesstypeSorting: (state, action)=>{
            state.businesstypeDashboard.sorting=action.payload;
        },
        setBusinesstypeFilterCriteria : (state, action)=>{
            state.businesstypeDashboard.filterCriteria=action.payload;
        },
        setShowEditForBusinesstype: (state,action)=>{
            state.businesstypeDashboard.showEdit=action.payload;
            
        },
        addBusinesstypeObj: (state, action)=>{
            state.businesstypeList.unshift(action.payload);
            state.businesstypeDashboard.businesstypeList.unshift(action.payload);

            state.businesstypeDashboard.businesstypeObj=action.payload;
            state.businesstypeDashboard.selectedId=action.payload.id;
        },
        updateBusinesstypeObj: (state, action)=>{
            let index = state.businesstypeList.map(businesstypeObj=>businesstypeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businesstypeList[index]=action.payload;
            }

            index = state.businesstypeDashboard.businesstypeList.map(businesstypeObj=>businesstypeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businesstypeDashboard.businesstypeList[index]=action.payload;
            }
            if (state.businesstypeDashboard.businesstypeObj!==null){
                state.businesstypeDashboard.businesstypeObj = action.payload;
            }
        },
        deleteBusinesstypeObj: (state, action)=>{
            state.businesstypeList.splice(state.businesstypeList.findIndex(a => a.id === action.payload) , 1);
            state.businesstypeDashboard.businesstypeList.splice(state.businesstypeDashboard.businesstypeList.findIndex(a => a.id === action.payload) , 1);
            state.businesstypeDashboard.productObj={}
            state.businesstypeDashboard.selectedId=-1
        },
        setSelectedBusinesstypeId: (state, action)=>{
            if (action.payload!==-1){
                state.businesstypeDashboard.selectedId=action.payload;
                state.businesstypeDashboard.businesstypeObj = state.businesstypeList[
                    state.businesstypeList.findIndex(businesstypeObj=>businesstypeObj.id===parseInt(action.payload))
            ];
            } else {
                state.businesstypeDashboard.selectedId=action.payload;
                state.businesstypeDashboard.businesstypeObj ={}
            }
        },
        setBusinesstypeList: (state, action) =>{
            state.businesstypeList=action.payload;
            state.businesstypeDashboard.businesstypeList=action.payload;
        },
        setBusinesstypeDashboardBusinesstypeList: (state, action) =>{
            state.businesstypeDashboard.businesstypeList=action.payload;
        },
    }
});
export const { setActionList, setSelectedActionId, setProductSorting,setProductList,getProductList,updateProductObj,addProductObj,deleteProductObj,
setSelectedProductId,
setProductDashboardProductList,
setShowEditForProduct,
setProductFilterCriteria,
setProductEditProductModal,
setProductManageProductModal,
setProductLinkImageModal,setCategorySorting,setCategoryList,getCategoryList,updateCategoryObj,addCategoryObj,deleteCategoryObj,
setSelectedCategoryId,
setCategoryDashboardCategoryList,
setShowEditForCategory,
setCategoryFilterCriteria,setProductcategorySorting,setProductcategoryList,getProductcategoryList,updateProductcategoryObj,addProductcategoryObj,deleteProductcategoryObj,
setSelectedProductcategoryId,
setProductcategoryDashboardProductcategoryList,
setShowEditForProductcategory,
setProductcategoryFilterCriteria,setCustomerSorting,setCustomerList,getCustomerList,updateCustomerObj,addCustomerObj,deleteCustomerObj,
setSelectedCustomerId,
setCustomerDashboardCustomerList,
setShowEditForCustomer,
setCustomerFilterCriteria,setMlmuserSorting,setMlmuserList,getMlmuserList,updateMlmuserObj,addMlmuserObj,deleteMlmuserObj,
setSelectedMlmuserId,
setMlmuserDashboardMlmuserList,
setShowEditForMlmuser,
setMlmuserFilterCriteria,
setMlmuserTandcModal,
setMlmuserOnboardModal,
setMlmuserEdituserModal,
setMlmuserInitPartnershipModal,
setMlmuserManagePartnershipModal,
setMlmuserAddUserModal,setMlmusertypeSorting,setMlmusertypeList,getMlmusertypeList,updateMlmusertypeObj,addMlmusertypeObj,deleteMlmusertypeObj,
setSelectedMlmusertypeId,
setMlmusertypeDashboardMlmusertypeList,
setShowEditForMlmusertype,
setMlmusertypeFilterCriteria,setMlmcreditSorting,setMlmcreditList,getMlmcreditList,updateMlmcreditObj,addMlmcreditObj,deleteMlmcreditObj,
setSelectedMlmcreditId,
setMlmcreditDashboardMlmcreditList,
setShowEditForMlmcredit,
setMlmcreditFilterCriteria,setMlmorderSorting,setMlmorderList,getMlmorderList,updateMlmorderObj,addMlmorderObj,deleteMlmorderObj,
setSelectedMlmorderId,
setMlmorderDashboardMlmorderList,
setShowEditForMlmorder,
setMlmorderFilterCriteria,setRazororderSorting,setRazororderList,getRazororderList,updateRazororderObj,addRazororderObj,deleteRazororderObj,
setSelectedRazororderId,
setRazororderDashboardRazororderList,
setShowEditForRazororder,
setRazororderFilterCriteria,
setRazororderManageRazorOrderModal,setRazorsyncSorting,setRazorsyncList,getRazorsyncList,updateRazorsyncObj,addRazorsyncObj,deleteRazorsyncObj,
setSelectedRazorsyncId,
setRazorsyncDashboardRazorsyncList,
setShowEditForRazorsync,
setRazorsyncFilterCriteria,setTransferreqSorting,setTransferreqList,getTransferreqList,updateTransferreqObj,addTransferreqObj,deleteTransferreqObj,
setSelectedTransferreqId,
setTransferreqDashboardTransferreqList,
setShowEditForTransferreq,
setTransferreqFilterCriteria,setPayoutaccountSorting,setPayoutaccountList,getPayoutaccountList,updatePayoutaccountObj,addPayoutaccountObj,deletePayoutaccountObj,
setSelectedPayoutaccountId,
setPayoutaccountDashboardPayoutaccountList,
setShowEditForPayoutaccount,
setPayoutaccountFilterCriteria,setRazorwebhookSorting,setRazorwebhookList,getRazorwebhookList,updateRazorwebhookObj,addRazorwebhookObj,deleteRazorwebhookObj,
setSelectedRazorwebhookId,
setRazorwebhookDashboardRazorwebhookList,
setShowEditForRazorwebhook,
setRazorwebhookFilterCriteria,setBusinesscategorySorting,setBusinesscategoryList,getBusinesscategoryList,updateBusinesscategoryObj,addBusinesscategoryObj,deleteBusinesscategoryObj,
setSelectedBusinesscategoryId,
setBusinesscategoryDashboardBusinesscategoryList,
setShowEditForBusinesscategory,
setBusinesscategoryFilterCriteria,setBusinessserviceSorting,setBusinessserviceList,getBusinessserviceList,updateBusinessserviceObj,addBusinessserviceObj,deleteBusinessserviceObj,
setSelectedBusinessserviceId,
setBusinessserviceDashboardBusinessserviceList,
setShowEditForBusinessservice,
setBusinessserviceFilterCriteria,setBusinessservicedescSorting,setBusinessservicedescList,getBusinessservicedescList,updateBusinessservicedescObj,addBusinessservicedescObj,deleteBusinessservicedescObj,
setSelectedBusinessservicedescId,
setBusinessservicedescDashboardBusinessservicedescList,
setShowEditForBusinessservicedesc,
setBusinessservicedescFilterCriteria,setBusinessserviceassetSorting,setBusinessserviceassetList,getBusinessserviceassetList,updateBusinessserviceassetObj,addBusinessserviceassetObj,deleteBusinessserviceassetObj,
setSelectedBusinessserviceassetId,
setBusinessserviceassetDashboardBusinessserviceassetList,
setShowEditForBusinessserviceasset,
setBusinessserviceassetFilterCriteria,setBusinesstypeSorting,setBusinesstypeList,getBusinesstypeList,updateBusinesstypeObj,addBusinesstypeObj,deleteBusinesstypeObj,
setSelectedBusinesstypeId,
setBusinesstypeDashboardBusinesstypeList,
setShowEditForBusinesstype,
setBusinesstypeFilterCriteria, } = DmpSlice.actions;
export default DmpSlice.reducer;